import { StoreFinderButton } from "@omni/components/components/Navigation/Buttons/StoreFinderButton/storeFinderButton";

import { HeaderButtonComponent } from "@/components/Navigation/Buttons/HeaderButton/headerButton.component";

export const StoreFinderButtonComponent = () => {
    const { headerButtonProps, store } = StoreFinderButton.useContext();

    return (
        <HeaderButtonComponent {...headerButtonProps}>
            {store && <StoreFinderButton.Content />}
        </HeaderButtonComponent>
    );
};
